'use client';

import { useSatelliteWebLandlordConversationHandler_addMessage } from '@zg-rentals/ts-satellite-client-react-query';

/**
 * Landlord-side counterpart to the renter `useSendMessage`. Keeps the satellite
 * client dependency inside this module so consumers don't call the satellite
 * service directly (Proxit).
 */
export function useLandlordAddMessage() {
  return useSatelliteWebLandlordConversationHandler_addMessage({
    meta: {
      context: { api: 'satellite-api', details: 'landlordAddMessage' },
    },
  });
}
